module.exports = {
  eligibility: require('./modules/eligibility'),
  fdb: require('./modules/fdb'),
  dictionary: require('./modules/dictionary'),
  projects: require('./modules/projects'),
  user: require('./modules/user')
}
